<template>
  <div
    class="tw-absolute tw-left-0 tw-top-0 tw-z-10 tw-flex tw-h-full tw-w-full tw-items-start tw-justify-center tw-p-8 tw-backdrop-blur-sm"
  >
    <BaseButton
      v-if="hasRole(ROLE.GUEST)"
      color="primary"
      @click="openModal(UNLOCK_FULL_ACCESS_MODAL_NAME)"
    >
      <LockIcon class="tw-mr-2 tw-h-4 tw-w-4" />
      Register to view profiles
    </BaseButton>
    <BaseButton
      v-else-if="hasAccess(ACCESS_TYPE.NONE)"
      color="primary"
      href="/upgrade_plan/new"
      is-inertia-link
    >
      <LockIcon class="tw-mr-2 tw-h-4 tw-w-4" />
      Subscribe to unlock
    </BaseButton>
    <BaseButton
      v-else-if="isProfileStatus(PROFILE_STATUS.NOT_COMPLETE)"
      color="primary"
      :href="currentUser.profileUrl"
      is-inertia-link
    >
      <LockIcon class="tw-mr-2 tw-h-4 tw-w-4" />
      Complete your profile
    </BaseButton>
    <BaseButton
      v-else-if="isProfileVisibility(PROFILE_VISIBILITY.INVISIBLE)"
      color="primary"
      href="/settings/profile/basic"
      is-inertia-link
    >
      <LockIcon class="tw-mr-2 tw-h-4 tw-w-4" />
      Make your profile visible
    </BaseButton>
    <BaseButton
      v-else-if="!accessControl.subscription.privileges.filterCommunityMembers"
      color="primary"
      href="/subscription/plans"
      is-inertia-link
    >
      <LockIcon class="tw-mr-2 tw-h-4 tw-w-4" />
      Upgrade to Pro
    </BaseButton>

    <UnlockFullAccessModal v-if="!isUserLoggedIn" />
  </div>
</template>

<script setup>
import BaseButton from '@/shared/components/BaseButton.vue'
import LockIcon from '@/assets/images/icons/lock.svg'
import UnlockFullAccessModal from '@/shared/components/modals/UnlockFullAccessModal.vue'
import { UNLOCK_FULL_ACCESS_MODAL_NAME } from '@/shared/data/globalVariables.js'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { useCurrentUser } from '@/shared/composables/useCurrentUser'
import {
  ACCESS_TYPE,
  PROFILE_STATUS,
  PROFILE_VISIBILITY,
  ROLE,
} from '@/shared/data/permissionSystem.js'
import { useModals } from '@/shared/composables/useModals.js'

const {
  isUserLoggedIn,
  accessControl,
  isProfileVisibility,
  isProfileStatus,
  hasAccess,
  hasRole,
} = usePermissionSystem()
const { currentUser } = useCurrentUser()
const { openModal } = useModals()
</script>
